export default __webpack_public_path__ + "static/media/active_users.730bd761.svg";